/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import PasswordResetUpdateView from '../../view/pages/public/PasswordResetUpdateView'
import PasswordResetUpdateStore from '../../store/user/PasswordResetUpdateStore'

function getStores() {
  return [PasswordResetUpdateStore]
}

function getState(prevState, props) {
  return {
    state: PasswordResetUpdateStore.getState(),
    ...props
  }
}

export default withRouter(Container.createFunctional(PasswordResetUpdateView, getStores, getState, { withProps: true }))
